import {useEffect, useState} from 'react'
import {css} from '@emotion/react'
import Lottie from 'react-lottie'
import {colors} from '../constants'
import {createMarkup} from '../util/datoCmsDataFactory'

import SuccessConfetti from './SuccessConfetti'

const CONTAINER_STYLES = `
    position: relative;
    width: 1200px;
    margin: auto;
    padding: 0 1rem 5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const translationsData = {
    en: {
        title: `Success!`,
        subTitle: `Now, keep Startpage as your search engine:`,
        tagline: `Enter your search query into the URL bar and select ‘<b>Keep It</b>’ to ensure private searching.`,
    },
    de: {
        title: `Glückwunsch!`,
        subTitle: `Behalte Startpage als Standardsuchmaschine:`,
        tagline: `Gib deine Suchanfrage in die URL-Leiste ein und wähle “<b>Beibehalten</b>”, um immer anonym zu suchen.`,
    },
}

const HeroProtectionSuccess = ({languageCode = `en`}) => {
    const translations = translationsData[languageCode]

    const [animationData, setAnimationData] = useState({})

    useEffect(() => {
        // eslint-disable-next-line global-require, import/no-dynamic-require
        setAnimationData(require(`../images/protection/animation/${languageCode}/extension-install-instructions.json`))
    }, [languageCode])

    const renderInstructionAnimation = () => {
        const options = {
            loop: true,
            autoplay: true,
            animationData,
        }
        return <Lottie options={options} />
    }

    return (
        <section
            css={css`
            ${CONTAINER_STYLES}
            color: ${colors.midnight};
            h2 {
                color: ${colors.midnightAlt};
                font-size: 36px;
                margin: 24px 0;
            }
            h3 {
                color: ${colors.brandBlue};
                font-weight: 500;
                font-size: 16px;
            }
            p {
                line-height: 24px;
                font-size: 18px;
            }
        `}
        >
            <div
                className="background-circle"
                css={css`
                    position: absolute;
                    right: 500px;
                    top: 0;
                    border-radius: 50%;
                    height: 900px;
                    width: 900px;
                    background: #feeaa7;
                    right: -550px;
                    top: -262px;
                `}
            />
            <div
                className="instruction-text"
                css={css`
                    max-width: 534px;
                `}
            >
                <SuccessConfetti languageCode={languageCode} />
                <h2>{translations.subTitle}</h2>
                <p dangerouslySetInnerHTML={createMarkup(translations.tagline)} />
            </div>
            <div className="instruction-animation">{renderInstructionAnimation()}</div>
        </section>
    )
}

export default HeroProtectionSuccess
